export default "__VITE_ASSET__4cadec0b__"